import { Rule } from "antd/lib/form";
import { ColumnsType } from "antd/lib/table";
import React from "react";
import { IBaseComponent, IBaseProps, IBaseStates } from "../infrastructure/baseComponent";
import { IEntity, IFetchingResult, IOrdering, IPaging } from "../infrastructure/models";
import { Breakpoint } from "antd/lib/_util/responsiveObserve";

export enum enmPropertyType {
    string = 1,
    date = 2,
    time = 3,
    datetime = 4,
    boolean = 5,
    number = 6
}

export enum enmControlType {
    textbox = 1,
    numberinput = 2,
    checkbox = 3,
    date = 4,
    datetime = 5,
    autocomplete = 6, // autocomplete
    dropdown = 7,
    combobox = 8,
    lookup = 9,
    template = 10,
    password = 11,
    email = 12,
    priceinput = 13
}

export interface IProperty {
    title?: string;
    dataIndex?: string;
    width?: number | string;
    key?: string;
    allowNull?: boolean;
    disabled?: boolean;
    disable?: (sender: any) => boolean;
    propertyType?: enmPropertyType;
    controlType?: enmControlType;
    showColumn?: boolean;
    showControl?: boolean;
    renderColumn?: (value: any, record: any, index: number) => React.ReactNode | undefined;
    renderControl?: (currentEntity: any) => React.ReactNode | undefined;
    renderExtraParams?: (currentEntity: any) => any | undefined;
    rules?: Rule[];
    fixed?: 'left' | 'right';
    responsive?: Breakpoint[];
    rulesFunc?: (currentEntity: any) => Rule[] | undefined;
    visibility?: (currentEntity: any) => boolean | undefined;
    showInLookup?: boolean;
    combobox?: {
        options?: { value?: any; title?: string; }[];
        optionsFunc?: (sender: any, record: any) => { value?: any; title?: string; }[];
        defaultValue?: any;
        mode?: 'multiple' | 'tags';
    };
    lookup?: {
        lookupComponent: React.ComponentType<any> | string;
        lookupProperty: string;
        lookupDisplayFields: string[];
        dropdownDisplayFields?: string[];
        showButton?: boolean;
    };
    precision?: number;
    filterable?: boolean;
    sortable?: boolean;
    formatter?: (value: any | undefined, info: {
        userTyping: boolean;
        input: string;
    }) => string;
    parser?: (displayValue: string | undefined) => string | number;
    maxLength?: number;
    minLength?: number;
    onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>, value: any) => void;
}

export interface IMetadata {
    name: string;
    title: string;
    showHistory?: boolean;
    Properties: IProperty[];
    excludeNavigationFromSearch?: boolean;
}

export interface IEntityManagerProps<TEntity extends IEntity> extends IBaseProps {
    defaultId?: number;
    defaultState?: enmEntityManagerState;
    showHeader?: boolean;
    dataformBoxShadow?: boolean;
    hasBack?: boolean;
    onClose?: (sender: any) => void;
    preLoad?: boolean;
    onEntitySaving?: (entity: TEntity) => boolean;
    onEntitySaved?: (entity: TEntity) => void;
    onLoaded?: (initialData: IInitialData) => void;
    onStateChanged?: (prevSate: enmEntityManagerState, state: enmEntityManagerState) => void;
    extraHeaderNodes?: () => React.ReactNode;
    extraViewNode?: () => React.ReactNode;
    onDataFetched?: (data: IFetchingResult<TEntity>) => void;
    backNode?: (state: enmEntityManagerState) => React.ReactNode;
}

export enum enmEntityManagerState {
    List = 0,
    View = 1,
    New = 2,
    Edit = 3,
    Delete = 4
}

export interface IEntityManager extends IBaseComponent {
    preLoad?: boolean;
    metadata: IMetadata;
    fetchData(handleResultByInvoker?: boolean): Promise<void>;
    search(value?: string, selectedRowGuid?: string, paging?: IPaging, ordering?: IOrdering, handleResultByInvoker?: boolean): Promise<void>;
}

export interface IEntityManagerStates<TEntity extends IEntity> extends IBaseStates {
    data: TEntity[];
    totalResultCount?: number;
    state: enmEntityManagerState;
    columns: ColumnsType<any>;
    expandedRowKeys: React.Key[];
    currentEntity?: TEntity;
}

export interface IInitialParams {

}

export interface IInitialData {
    AccessList: { [key: string]: boolean };
}

